import { useTranslation } from "react-i18next";

import Icons from "@/components/icons";
import ModernPageLayout from "@/components/layout/ModernPageLayout";

function InsightsLoadingError() {
  const { t } = useTranslation();

  return (
    <ModernPageLayout title={t("common.insights")}>
      <div className="flex flex-col items-center justify-center gap-4 py-12 min-h-[400px]">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10">
          <Icons.WarningIcon fontSize={32} className="text-destructive" />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <h3 className="text-lg font-semibold text-foreground">
            {t("common.insightsLoadErrorTitle")}
          </h3>
          <p className="text-sm text-muted-foreground max-w-md">
            {t("common.insightsLoadErrorDescription")}
          </p>
        </div>
      </div>
    </ModernPageLayout>
  );
}

export default InsightsLoadingError;
